import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';
import { EModelName } from './model-name';

const MeetingBotLogSchema = new mongoose.Schema({
  users: {
    type: [mongoose.Schema.Types.ObjectId],
    required: true,
    ref: EModelName.USER,
  },
  botId: { type: String },
  scheduledAt: { type: Date },
  created: { type: Date, default: Date.now() },
  endedAt: { type: Date },
  inWaitingRoomAt: { type: Date },
  recordingStartedAt: { type: Date },
  transciptDoneAt: { type: Date },
  botFatalAt: { type: Date },
  processCompleted: { type: Date },
  meetingType: { type: String },
  meetingTool: { type: String },
  endedReason: { type: String },
  isRecurring: { type: Boolean },
  attendees: { type: [String] },
  meetingId: { type: String },
  followUpEmailCreated: { type: Boolean },
  summarySharedExternally: { type: Boolean },
});

export type T_MeetingBotLogBase = InferSchemaType<typeof MeetingBotLogSchema>;

// Add specific type information for meeting tool and type
export interface T_MeetingBotLog extends Omit<T_MeetingBotLogBase, 'meetingType' | 'meetingTool' | 'users'> {
  meetingType?: 'ad-hoc' | 'scheduled';
  meetingTool?: 'google' | 'zoom' | 'teams' | 'webex' | 'other';
  users: string[];
}

export type T_MeetingBotLogDocument = T_MeetingBotLog &
  Document & {
    _id: string;
  };

export { MeetingBotLogSchema };
